import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import router from "./utils/router/router";
import { useSelector } from "react-redux";
import { useEffect } from "react";

function App() {
  const faviconUrl = useSelector(
    (state) =>
      state.common.agDetails?.files?.icon_media_id?.media_url || ""
  );

  useEffect(() => {
    const updateFavicon = (url) => {
      let link = document.querySelector("link[rel='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = url;
    };

    if (faviconUrl) {
      updateFavicon(faviconUrl);
    }
  }, [faviconUrl]);

  return (
    <>
      <RouterProvider router={router} />
      <ToastContainer limit={4} autoClose={3000} />
    </>
  );
}

export default App;
